module.exports = __webpack_public_path__ + "static/media/61.b30d1dda.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/61.jpg
// module id = 1003
// module chunks = 0